import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../../../utils/ModalEventListener";
const SuperMakerConfirmModal = ({ closeSuperMakerConfirmModal }) => {
  const ref = useRef();

  useEffect(() => {
    return modalEventListener(ref, closeSuperMakerConfirmModal);
  }, [closeSuperMakerConfirmModal]);
  return ReactDOM.createPortal(
    <>
      <div className="modal-wrapper">
        <div className="super-maker-confirm-modal-content" ref={ref}>
          <div class="modal-header">
            <h4 class="modal-title">&nbsp;</h4>
          </div>
          <div class="modal-body clearfix">
            <label id="confirm_submit_lable">
              Your request has been initiated, Please wait while we process your
              request.
            </label>
          </div>
          <div class="modal-footer">
            <h4 class="modal-title">&nbsp;</h4>
          </div>
        </div>
      </div>
    </>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default SuperMakerConfirmModal;
